<template>
  <PopupContent class="popup-calendar">
    <CalendarDate
      :size="size"
      :value="value"
      :range="range"
      :events="events"
      :holidays="holidays"
      :disabled-dates="disabledDates"
      :disabled-past-dates="disabledPastDates"
      :start-year="startYear"
      :end-year="endYear"
      @range-start-selected="reemitToEventBus('range-start-selected', $event)"
      @range-selected="handleSelectedDate('range-selected', $event)"
      @date-selected="handleSelectedDate('date-selected', $event)"
      @input="reemitToEventBus('input', $event)"
    />
  </PopupContent>
</template>

<script>
import { POPUP_EVENTS } from '../../config';
import PopupContent from '../popup-content';
import { eventBusReemiter } from '@/shared/lib/event-bus';
import { CalendarDate } from '@/shared/ui/calendar';

export default {
  props: {
    popupId: {
      type: String,
      required: false,
      default: null,
    },
    size: {
      type: String,
      default: 'small',
      validator: (value) => ['normal', 'small'].includes(value)
    },
    value: {
      type: [String, Date, Object, Array],
      default: null,
    },
    range: {
      type: Boolean,
      default: false,
    },
    events: {
      type: Array,
      default: () => [],
      validator: (value) => value.every((event) => event.date),
    },
    holidays: {
      type: Array,
      default: () => [],
      validator: (value) => value.every((holiday) => holiday.date),
    },
    disabledDates: {
      type: Array,
      default: () => [],
      validator: (value) => value.every((item) => {
        return item && (typeof item === 'string' || item instanceof Date || (typeof item === 'object' && item.date));
      }),
    },
    disabledPastDates: {
      type: Boolean,
      default: false,
    },
    startYear: {
      type: Number,
      default: null,
    },
    endYear: {
      type: Number,
      default: null,
    },
  },
  mixins: [ eventBusReemiter ],
  components: { PopupContent, CalendarDate },
  methods: {
    handleSelectedDate(eventName, event) {
      this.$eventBus.$emit(POPUP_EVENTS.CLOSE, this.popupId);
      this.reemitToEventBus(eventName, event);
    },
  },
};
</script>

<style lang="scss" scoped>
.popup-calendar {
  display: flex;
  justify-content: center;
}
</style>
